
import GrossDemandDeterminationTable from "../component/GrossDemandDeterminationTable";
import { Route,Routes } from 'react-router-dom';
import GrossCarSegmentDDTable from "../component/GrossCarSegmentDDTable";
import FleetPlanningTitleNavigation from "../component/FleetPlanningTitleNavigation";
import FleetPlanningMainTitle  from "../component/FleetPlanningMainTitle";
import BrandCrudTable from "../component/brandCrud/BrandCrudTable";

const BrandPlanning = () => {
    return (
        <div>
          
            <Routes>
            <Route path="/"  element={<BrandCrudTable/>}/>
            </Routes>
            
        </div>
           
    );
}

export default BrandPlanning;